type ContentFacetValue = {
  facetAttributes?: Record<string, string>
  [key: string]: Record<string, string> | undefined
}

export type ContentFacets = Record<string, ContentFacetValue>

export default function getGroupedFacets(
  facets: string[],
  contentFacets?: ContentFacets
) {
  const groupedFacets = facets.reduce(
    (acc: Record<string, string[]>, facet: string) => {
      let prefix = facet.split('-').slice(0, 2).join('-')

      if (contentFacets) {
        for (const [key, value] of Object.entries(contentFacets)) {
          if (value?.facetAttributes?.[facet]) {
            prefix = key
          }
        }
      }

      if (!acc[prefix]) {
        acc[prefix] = []
      }
      acc[prefix].push(facet)
      return acc
    },
    {}
  )
  return groupedFacets
}
